import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useCreateNewContact from '../../../../hooks/dashboard/trip-log/useCreateNewContact';
import {
  AddContactInitialValues,
  AddContactSchema,
} from '../../../../models/dashboard/trip-log/add-contact';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface AddNewContactModalProps {
  email?: string;
}

const AddNewContactModal: React.FC<AddNewContactModalProps> = ({ email }) => {
  const modalContext = useContext(ModalContext);
  const { createNewContact, loading } = useCreateNewContact();

  const onSubmit = (value: any) => {
    createNewContact(value, () => modalContext?.setShowModal(false));
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (email?.trim() && emailRegex.test(email.trim())) {
    AddContactInitialValues.email = email.trim();
  } else {
    AddContactInitialValues.email = '';
  }

  return (
    <ModalContainer label='Add New Contact'>
      <FormComponent
        initialValues={AddContactInitialValues}
        schema={AddContactSchema}
        onSubmit={onSubmit}
      >
        <TextInputField
          type='text'
          label='Customer Name'
          name='name'
          id='name'
          placeholder='Customer Name'
        />

        <TextInputField
          type='email'
          label='Customer email'
          name='email'
          id='email'
          placeholder='Customer email'
        />

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton className='blue-solid fill' loading={loading}>
            Save
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default AddNewContactModal;

const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
`;
